/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from 'i18next';
import { Translation } from 'react-i18next';
import { isEmpty } from 'lodash';
import {
  getTenantState,
  getPreRegistrationState,
} from '../../../store/selectors';
import { addEducation } from '../../../store/actions';
import { education } from '../../../copy/onboardingCopy.json';
import EducationSlider from './EducationSlider';
import EducationIcon from './EducationIcon';
import ProgressBar from '../../utility/ProgressBar';
import LoginButton from '../../utility/LoginButton';
import RouteBack from '../../utility/RouteBack';
import NextButton from '../../utility/NextButton';
import SchoolLogo from '../../utility/SchoolLogo';
import rightCircle from '../../../ASUPhotos/icons/me3_RightCircle_Icon.png';
import BackArrow from '../../utility/BackArrow';
import { educationPage_GTM } from '../../../gtm/datalayers/educationDataLayers.json';
import { fireGTM } from '../../../gtm/gtmUtil';
import PoweredByASUBlackAndWhite from '../../utility/PoweredByASUBlackAndWhite';
import GradYearDropdown from './GradYearDropdown';
import { educationLevels } from '../../../copy/educationLevels';
import LanguageDropdown from '../../LanguageDropdown';
import WindowTitle from '../../utility/WindowTitle';

const currentYear = new Date().getFullYear();
const yearChoices = [
  { value: currentYear, label: currentYear },
  { value: currentYear + 1, label: currentYear + 1 },
  { value: currentYear + 2, label: currentYear + 2 },
  { value: currentYear + 3, label: currentYear + 3 },
  { value: currentYear + 4, label: currentYear + 4 },
];
class Education extends Component {
  constructor(props) {
    super(props);
    this.state = {
      percent: 10,
      educationLevelDiff: 10,
      // Make sure slider-bar represents a previous value if previously selected
      sliderPercent: this.checkSliderPercent(),
      // Check if user has already selected education level before
      educationTextInfo: this.checkEducationTextInfo(),
      // Show left arrow if they previously selected an education level
      showLeftArrow: this.checkLeftArrow(),
      // Show right arrow as long as previous education level wasn't the last option
      showRightArrow: this.checkRightArrow(),
      // Don't allow the user to reset education choice once already selected
      educationLevelSelected: false,
      graduationYear: '',
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyPress);
    if (this.props.tenant.name === 'Baobab') {
      this.setState({
        graduationYear: this.props.preregistration.education.graduationYear,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyPress);
  }

  secondaryBorderLarge = {
    borderTop: `11px solid ${this.props.tenant.secondary}`,
  };

  secondaryBorder = {
    borderBottom: `5px solid ${this.props.tenant.secondary}`,
  };

  checkSliderPercent = () => {
    if (
      isEmpty(this.props.preregistration.education) ||
      !this.props.educationLevel
    ) {
      return 0;
    }

    return this.props.preregistration.education.sliderBarValue;
  };

  checkEducationIcon = () => {
    if (
      isEmpty(this.props.preregistration.education) ||
      !this.props.educationLevel
    ) {
      return rightCircle;
    }

    return this.props.preregistration.education.educationIcon;
  };

  checkEducationTextInfo = () => {
    if (
      isEmpty(this.props.preregistration.education) ||
      !this.props.educationLevel
    ) {
      return {
        value: 'Slide Right',
        label: i18n.t('Slide Right'),
      };
    }

    const educationLevelInfo = Object.values(educationLevels()).find(
      (level) =>
        level.value === this.props.preregistration.education.educationLevel
    );

    return educationLevelInfo || {};
  };

  checkLeftArrow = () => {
    if (isEmpty(this.props.preregistration.education)) {
      return false;
    }

    return true;
  };

  checkRightArrow = () => {
    // The user did not select an education level previously
    if (isEmpty(this.props.preregistration.education)) {
      return true;
      // The user selected an education level but it wasn't the final option
    }

    if (
      !isEmpty(this.props.preregistration.education) &&
      this.props.preregistration.education.sliderBarValue < 99
    ) {
      return true;
      // User selected the final education level option
    }

    return false;
  };

  // The values of 'x' are not consistent so need to account for two rounded values
  checkSliderChange = async (x) => {
    // Did they select past the last icon on the right hand side?
    const roundX = x === 100 ? 90 : Math.round(x);

    // Only change the slider if the clicked area was greater than 0
    if (roundX > 0) {
      this.setState({
        sliderPercent: roundX,
        educationLevelSelected: true,
      });
      // Did the user select the left-side tail of the slider or try to drag the thumb all the way to the left?
    } else if (roundX < 10 && this.state.educationLevelSelected) {
      this.setState({
        sliderPercent: 10,
        educationTextInfo: educationLevels().level1,
        showLeftArrow: false,
        showRightArrow: true,
      });
      this.props.addEducation({
        educationLevel: educationLevels().level1.value,
        sliderBarValue: roundX,
      });
    }

    // Don't let the user reset their choice to empty if they've already selected an education level
    if (roundX === 0 && !this.state.educationLevelSelected) {
      this.setState({
        educationTextInfo: {
          value: 'Slide Right',
          label: i18n.t('Slide Right'),
        },
        showLeftArrow: false,
        showRightArrow: true,
      });
      this.props.addEducation({
        sliderBarValue: this.props.preregistration.education.sliderBarValue,
        educationIcon: rightCircle,
      });
    } else if (roundX === 10 || roundX === 11) {
      this.setState({
        educationTextInfo: educationLevels().level1,
        showLeftArrow: false,
        showRightArrow: true,
      });
      this.props.addEducation({
        educationLevel: educationLevels().level1.value,
        sliderBarValue: roundX,
      });
    } else if (roundX === 20 || roundX === 21) {
      this.setState({
        educationTextInfo: educationLevels().level2,
        showLeftArrow: true,
        showRightArrow: true,
      });
      this.props.addEducation({
        educationLevel: educationLevels().level2.value,
        sliderBarValue: roundX,
      });
    } else if (roundX === 30 || roundX === 31) {
      this.setState({
        educationTextInfo: educationLevels().level3,
        showLeftArrow: true,
        showRightArrow: true,
      });
      this.props.addEducation({
        educationLevel: educationLevels().level3.value,
        sliderBarValue: roundX,
      });
    } else if (roundX === 40 || roundX === 41) {
      this.setState({
        educationTextInfo: educationLevels().level4,
        showLeftArrow: true,
        showRightArrow: true,
      });
      this.props.addEducation({
        educationLevel: educationLevels().level4.value,
        sliderBarValue: roundX,
      });
    } else if (roundX === 50 || roundX === 51) {
      this.setState({
        educationTextInfo: educationLevels().level5,
        showLeftArrow: true,
        showRightArrow: true,
      });
      this.props.addEducation({
        educationLevel: educationLevels().level5.value,
        sliderBarValue: roundX,
      });
    } else if (roundX === 60 || roundX === 61) {
      this.setState({
        educationTextInfo: educationLevels().level6,
        showLeftArrow: true,
        showRightArrow: true,
      });
      this.props.addEducation({
        educationLevel: educationLevels().level6.value,
        sliderBarValue: roundX,
      });
    } else if (roundX === 70 || roundX === 71) {
      this.setState({
        educationTextInfo: educationLevels().level7,
        showLeftArrow: true,
        showRightArrow: true,
      });
      this.props.addEducation({
        educationLevel: educationLevels().level7.value,
        sliderBarValue: roundX,
      });
    } else if (roundX === 80 || roundX === 81) {
      this.setState({
        educationTextInfo: educationLevels().level8,
        showLeftArrow: true,
        showRightArrow: true,
      });
      this.props.addEducation({
        educationLevel: educationLevels().level8.value,
        sliderBarValue: roundX,
      });
    } else if (roundX === 90 || roundX === 91) {
      this.setState({
        educationTextInfo: educationLevels().level9,
        showLeftArrow: true,
        showRightArrow: false,
      });
      this.props.addEducation({
        educationLevel: educationLevels().level9.value,
        sliderBarValue: roundX,
      });
    }
  };

  handleIconKeyDown = async (e, value) => {
    if (['Enter'].includes(e.key)) {
      await this.checkSliderChange(value);
    }
  };

  handleKeyPress = (event) => {
    if (event.keyCode === 38 || event.keyCode === 39) {
      this.arrowClickHandler('addition');
    }

    if (event.keyCode === 37 || event.keyCode === 40) {
      this.arrowClickHandler('subtract');
    }
  };

  // If the user selects an arrow direction instead of the slider bar
  arrowClickHandler = async (operation) => {
    let diff;
    let sum;

    if (this.state.sliderPercent > 0 && operation === 'subtract') {
      diff = this.state.sliderPercent - this.state.educationLevelDiff;
      await this.checkSliderChange(diff);
      // Google Tag Manager
      educationPage_GTM.leftChevron.section =
        this.state.educationTextInfo.value.toLowerCase();
      fireGTM(educationPage_GTM.leftChevron);
    } else if (this.state.sliderPercent < 99 && operation === 'addition') {
      sum = this.state.sliderPercent + this.state.educationLevelDiff;
      await this.checkSliderChange(sum);
      educationPage_GTM.rightChevron.section =
        this.state.educationTextInfo.value.toLowerCase();
      fireGTM(educationPage_GTM.rightChevron);
    }
  };

  sliderEndFix = async () => {
    // This will make sure the slider thumb goes all the way to the right if the user clicks on the end of the slider
    await this.checkSliderChange(99);
  };

  setGradYear = (graduationYear) => {
    this.setState({ graduationYear });

    this.props.addEducation({
      educationLevel: educationLevels().level1.value,
      sliderBarValue: 10,
      graduationYear,
    });
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <>
            <WindowTitle>
              {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
              {t('Onboarding')} - {t('Education')}
            </WindowTitle>
            <div id="education-page" style={this.secondaryBorderLarge}>
              <div className="top-section">
                <div
                  className={`utility-container ${
                    this.props.auth.isAuthenticated ? 'auth' : null
                  }`}
                >
                  {this.props.auth.isAuthenticated ? null : (
                    <RouteBack
                      color={this.props.tenant.primary}
                      route="/landing"
                      tenant={this.props.tenant}
                      text="back"
                      section={this.state.educationTextInfo.value.toLowerCase()}
                    />
                  )}
                  <span className="education-right-header-group">
                    <span
                      className="education-right-header-item"
                      style={{
                        flex: '1 0 0',
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <LoginButton
                        tenant={this.props.tenant}
                        color={this.props.tenant.primary}
                        isAuthenticated={this.props.auth.isAuthenticated}
                        section="please indicate your highest level of education so me3 can provide the best result for you！"
                      />
                    </span>
                    <span
                      className="education-right-header-item"
                      hidden={this.props.tenant.name !== 'Baobab'}
                    >
                      <LanguageDropdown lowProfile />
                    </span>
                  </span>
                </div>
                <div className="logo-text-container">
                  {/* TODO: Make this more dyanmic but for now we know what the size should be on this specific page */}
                  <SchoolLogo
                    schoolLogoWidth="90%"
                    horizontalAlign="flex-start"
                  />
                  <div className="header-text-container">
                    <h1>
                      {t(
                        'Please indicate your highest level of education so me3 can provide the best results for you. Select the option that best applies then click/tap “Next.”'
                      )}
                    </h1>
                    <div className="fake-border" style={this.secondaryBorder} />
                  </div>
                  {/* Need this to center the header text */}
                  <div className="column is-one-quarter school-logo-container-game-dummy" />
                </div>
              </div>
              {/* --------------- Middle Section --------------- */}
              {/* --- Direction Arrows and Education Icon --- */}
              <div className="middle-section-container">
                <div className="columns is-mobile is-centered arrows-icon-container">
                  <div className="column is-narrow left-arrow-container">
                    {(() => {
                      if (this.state.showLeftArrow) {
                        return (
                          // prevent AXE errors:
                          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                          <figure
                            className="left-arrow"
                            id="left-arrow"
                            data-cy="left-arrow"
                            onClick={() => {
                              this.arrowClickHandler('subtract');
                            }}
                            onKeyDown={(e) => {
                              if (['Enter'].includes(e.key))
                                this.arrowClickHandler('subtract');
                            }}
                            aria-label="click to slide education level to the left or tab below to select"
                            tabIndex="0"
                          >
                            <BackArrow
                              size="35px"
                              color={this.props.tenant.primary}
                              title="Left arrow"
                            />
                          </figure>
                        );
                      }

                      return <figure className="image left-arrow" />;
                    })()}
                  </div>
                  <div className="arrow-spacer" />
                  <EducationIcon
                    educationTextEn={this.state.educationTextInfo.value}
                    tenant={this.props.tenant}
                  />
                  <div className="arrow-spacer" />
                  <div className="column is-narrow right-arrow-container">
                    {(() => {
                      if (this.state.showRightArrow) {
                        return (
                          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                          <figure
                            className="right-arrow"
                            id="right-arrow"
                            data-cy="right-arrow"
                            onClick={() => {
                              this.arrowClickHandler('addition');
                            }}
                            onKeyDown={(e) => {
                              if (['Enter'].includes(e.key))
                                this.arrowClickHandler('addition');
                            }}
                            aria-label="click to slide education level to the right or tab below to select"
                            tabIndex="0"
                          >
                            <BackArrow
                              size="35px"
                              color={this.props.tenant.primary}
                              title="Right arrow"
                            />
                          </figure>
                        );
                      }

                      return <figure className="image right-arrow" />;
                    })()}
                  </div>
                </div>
                <div className="column education-text-container has-text-centered">
                  <div className="content education-text">
                    <p>{this.checkEducationTextInfo().label}</p>
                  </div>
                </div>

                {/* --- Slider Bar --- */}
                <EducationSlider
                  tenant={this.props.tenant}
                  checkSliderChange={this.checkSliderChange}
                  sliderEndFix={this.sliderEndFix}
                  handleIconKeyDown={this.handleIconKeyDown}
                  educationLevelDiff={this.state.educationLevelDiff}
                  sliderPercent={this.state.sliderPercent}
                />
                {this.props.tenant.name === 'Baobab' &&
                  this.state.sliderPercent === 10 && (
                    <GradYearDropdown
                      setGradYearParent={this.setGradYear}
                      graduationYear={
                        this.props.preregistration.education.graduationYear ||
                        this.state.graduationYear
                      }
                    />
                  )}
                <NextButton
                  color={this.props.tenant.primary}
                  nextPath="location"
                  isActive={
                    this.state.sliderPercent === 10 &&
                    this.props.tenant.name === 'Baobab'
                      ? !!this.state.graduationYear
                      : !(this.state.sliderPercent === 0)
                  }
                  overRideStyle="education-next-button"
                  text="Next"
                  section={this.state.educationTextInfo.value}
                />
              </div>
              {/* --------------- Bottom Section --------------- */}
              <div className="bottom-section">
                <ProgressBar
                  bars={education.bars}
                  currentPhase={this.state.percent}
                  tenant={this.props.tenant}
                />
              </div>
              <PoweredByASUBlackAndWhite tenant={this.props.tenant} />
            </div>
          </>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const tenant = getTenantState(state);
  const preregistration = getPreRegistrationState(state);
  const auth = state.auth;

  return { tenant, preregistration, auth };
};

export default connect(mapStateToProps, { addEducation })(Education);
